import { locationIdFormat } from "@redotech/redo-inventory-id";
import { productIdFormat } from "@redotech/redo-product-id";
import { storageLocationIdFormat } from "@redotech/redo-warehouse-id";
import * as z from "zod";

export const getSuggestedTransferDestinations = {
  name: "getSuggestedTransferDestinations" as const,
  input: z.object({
    locationId: locationIdFormat.schema,
    productIds: z.array(productIdFormat.schema),
    sourceBins: z.array(
      z.object({
        storageLocationId: storageLocationIdFormat.schema,
        lineKeys: z.array(z.string()),
      }),
    ),
  }),
  output: z.object({
    destinations: z.array(
      z.object({
        productId: productIdFormat.schema,
        storageLocationId: storageLocationIdFormat.schema.nullable(),
        binName: z.string().nullable(),
      }),
    ),
  }),
};
